import { render, staticRenderFns } from "./CompanyAddModule.vue?vue&type=template&id=2facf1bc&scoped=true"
import script from "./CompanyAddModule.vue?vue&type=script&lang=js"
export * from "./CompanyAddModule.vue?vue&type=script&lang=js"
import style0 from "./CompanyAddModule.vue?vue&type=style&index=0&id=2facf1bc&prod&scoped=true&lang=scss"
import style1 from "./CompanyAddModule.vue?vue&type=style&index=1&id=2facf1bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2facf1bc",
  null
  
)

export default component.exports